import "./Laboratory.css"
import img1 from "../../assets/Group 3.png"
import img2 from "../../assets/Group 5.png"
import {useState, useEffect} from "react";
import Loading from "../UI/Loading/Loading";

const Laboratory = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [state, setState] = useState({
        email: null
    })

    const placeEmailHandler = (e) => {
        let val = e.target.value
        setState(val)
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        const loadingTimeout = setTimeout(() => {
            setIsLoading(false);
        }, 2000);

        return () => {
            clearTimeout(loadingTimeout);
        };
    }, [])

    return (
        <>
            {isLoading && <Loading/>}
            <div className={"laboratory-container"}>
                <div className="laboratory-first">
                    <h1 className={"upToBottomAnimation"}>
                        Arnika Laboratory
                    </h1>
                    <div className={"upToBottomAnimation"}>
                        Make the Right Decision.
                    </div>
                </div>
                <div className="laboratory-sec-container">
                    <div className={"laboratory-sec"}>
                        <div className={"laboratory-sec-left"}>
                            <img src={img1} alt=""/>
                            <h1 className={"FadeTextAnimation"}>
                                Engineering
                            </h1>
                            <p className={"FadeTextAnimation"}>
                                We believe that designing software systems is only part of our commitment to our client.
                                We
                                are
                                here
                                to
                                help you hone in your requirements, take input from you throughout the software
                                engineering
                                lifecycle
                                and mould the development to your specific needs providing you with a world class
                                support
                                and
                                maintenance service. A few of our services are;
                            </p>
                        </div>
                        <div className={"laboratory-sec-right"}>
                            <ol>
                                <li>
                                    Software Engineering
                                </li>
                                <li>
                                    Feasibility Study
                                </li>
                                <li>
                                    Systems Architecture and Design
                                </li>
                                <li>
                                    Software Development
                                </li>
                                <li>
                                    Project Management
                                </li>
                                <li>
                                    Testing & Quality Assurance
                                </li>
                                <li>
                                    Technical, Operational and Maintenance Documentation
                                </li>
                                <li>
                                    Support and Maintenance
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className={"laboratory-third-container"}>
                    <div className="laboratory-third">
                        <div>
                            <h1 className={"FadeTextAnimation"}>
                                Technology Stack
                            </h1>
                            <p className={"FadeTextAnimation"}>
                                Our seasoned professional developers can practically utilise all available and modern
                                technologies to construct sophisticated and enterprise class applications in either
                                Monolith
                                or Micro-service architectures.
                            </p>
                        </div>
                        <div>
                            <div>
                                <h1 className={"FadeTextAnimation"}>
                                    Languages:
                                </h1>
                                <p className={"FadeTextAnimation"}>
                                    Java, Python, PHP, Nodejs, Kotlin, .Net Core, Javascript, Jquery, C#, Swift, React
                                    Native…
                                </p>
                            </div>
                            <div>
                                <h1 className={"FadeTextAnimation"}>
                                    Frameworks:
                                </h1>
                                <p className={"FadeTextAnimation"}>
                                    JHipster, Spark, Spring, Vue, Strut, Tapestry, Hibernate, JSF, Grails, Django,
                                    Flask,
                                    Tornado, Web2Py, Laravel, Yii, Symfony, CodeIgnitor, PHPPixie, Angular, Bootstrap…
                                </p>
                            </div>
                            <div>
                                <h1 className={"FadeTextAnimation"}>
                                    Databases:
                                </h1>
                                <p className={"FadeTextAnimation"}>
                                    MySQL, NoSQL, PostgreSQL, Kafka, Oracle, Redis, Cassandra, Elasticsearch, Mongo...
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="laboratory-fourth-container">
                    <div className="laboratory-fourth">
                        <h1 className={"FadeTextAnimation"}>Graphics Design</h1>
                        <div className={"laboratory-fourth-txt FadeTextAnimation"}>
                            The power of clear, consistent branding that resonates across all of your business’s major
                            customer touch points can’t be underestimated. Presenting a unified language - across
                            visual,
                            messaging and digital mediums is critical to creating systems that are familiar, bold and
                            unapologetic of their value.
                        </div>
                        <div className={"laboratory-fourth-details"}>
                            <div className={"FadeTextAnimation"}>
                                <p>- Typography</p>
                                <p>- Logos</p>
                                <p>- Presentations</p>
                                <p>- Illustrations</p>
                                <p>- Complete Artwork Design & Asset Management</p>
                            </div>
                            <div className={"FadeTextAnimation"}>
                                <p>- UI&UX Design</p>
                                <p>- Campaigns</p>
                                <p>- Pamphlets</p>
                                <p>- Layouts</p>
                            </div>
                            <div className={"FadeTextAnimation"}>
                                <p>- Photography</p>
                                <p>- Motion Graphics</p>
                                <p>- Web Design</p>
                                <p>- Brochures</p>
                            </div>
                            <div className={"FadeTextAnimation"}>
                                <p>- Video Production</p>
                                <p>- Storytelling</p>
                                <p>- Application Design</p>
                                <p>- Poster Design</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="laboratory-fifth-container">
                    <div className="laboratory-fifth">
                        <img src={img2} alt=""/>
                        <h1 className={"FadeTextAnimation"}>SEO and Digital marketing</h1>
                        <p className={"laboratory-fifth-orange FadeTextAnimation"}>
                            Getting your digital strategy right is complicated, but that's why we're here.
                        </p>
                        <div className={"laboratory-fifth-txt FadeTextAnimation"}>
                            Even for the best digital destinations in the world, it takes planning, commitment and first
                            class execution to market your products. We know all about how to get the most out of your
                            digital campaigns, your day-to-day, ‘business as usual’ marketing activities, and how to
                            measure
                            these to make sure you’re on the right digital track.
                        </div>
                        <div className={"laboratory-fifth-details"}>
                            <div className={"FadeTextAnimation"}>
                                <p>- SEO & Digital Marketing</p>
                                <p>- International SEO Strategy Formulation</p>
                                <p>- Fully Integrated Campaign Strategy Formulation</p>
                                <p>- Brand/Business-aligned Social Strategy Formulation</p>
                                <p>- Content Development</p>
                            </div>
                            <div className={"FadeTextAnimation"}>
                                <p>- Traffic Conversion</p>
                                <p>- Site Structure Composition, Internal Linking,
                                    Crawlability, Meta Tags, Redirects, Site Maps & Speed</p>
                                <p>- KPI Development</p>
                                <p>- SEO & Campaign Audit & Reporting</p>
                                <p>- Total Analytics Imposition</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="laboratory-email">
                    <h1 className={"FadeTextAnimation"}>
                        Would you like to collaborate?
                    </h1>
                    <p className={"FadeTextAnimation"}>
                        Insert your email
                    </p>
                    <div className={"FadeTextAnimation"}>
                        <input type="email" name={"email"} value={state.email} onChange={placeEmailHandler}
                               placeholder={"example@gmail.com"}/>
                        <button>Send</button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Laboratory;